export const API_URL = "https://dev001-burger-queen-api-production.up.railway.app";
//export const API_URL = "https://ice-cream-queen-api.onrender.com";